import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CustomTooltipDirective } from '../../directives/custom-tooltip.directive';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  imports: [CommonModule, CustomTooltipDirective],
})
export class ChipComponent {
  @Input() name = '';
  @Input() email = '';
  @Input() imageUrl = '';
  @Input() class = '';
  @Input() isCollapsed = false;
  @Input() tooltipPosition:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-right'
    | 'bottom-right' = 'bottom-right';

  randomColor(name: string): string {
    const colors = [
      '#5F9EA0',
      '#9F9853',
      '#9A5656',
      '#8299B7',
      '#556B2F',
      '#708090',
      '#4682B4',
      '#575BB8',
      '#9370DB',
    ];
    if (!name) {
      return colors[0]; // Default color if no company name is provided
    } else {
      const index = name.length % colors.length;
      return colors[index];
    }
  }

  getInitials(name: string): string {
    if (name) {
      const words = name.split(' ').filter((word) => word.trim().length > 0);
      const initials = words.map((word) => word[0].toUpperCase()).join('');
      return initials.length > 2 ? initials.slice(0, 2) : initials;
    } else {
      return '';
    }
  }
}
